import makeStyles from '@mui/styles/makeStyles';

export const headerStyles = makeStyles(() => ({
  p3: {
    paddingTop: '1rem',
    paddingLeft: 16,
    paddingRight: 16,
    backgroundColor: 'white',
  },
  p2: {
    paddingTop: '16px',
    paddingBottom: '16px',
    backgroundColor: 'white',
    paddingLeft: '12px',
  },
  link: {
    cursor: 'pointer',
    color: '#000',
  },
  header: {
    boxShadow: ' inset 0px -1px 0px #E5E8EB',
    backgroundColor: '#fff',
    position: 'sticky',
    top: '0px',
    maxWidth: '425px',
    zIndex: 1,
  },
  paddingTop: {
    paddingTop: '1%',
    textAlign: 'center',
  },
  subTitle: {
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: 14,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    paddingRight: '16px',
  },
  title: {
    color: '#202223',
    fontSize: '20px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    lineHeight: '28px',
    fontWeight: 600,
    fontFamily: 'Inter',
    textAlign: 'center',
  },
  alignCenter: {
    textAlign: 'center',
  },
  imageContainer: {
    position: 'relative',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  accountContainer: {
    position: 'relative',
    height: '100%',
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center',
  },
  accountIcon: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'transparent',
    },
    paddingRight: '0px !important',
  },
  rightIconsContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    marginLeft: 'auto',
  },
  editAction: {
    textAlign: 'right',
    paddingRight: '16px',
    color: '#18A0D7',
    '& .MuiSvgIcon-root': {
      cursor: 'pointer',
    },
    '& button': {
      color: '#18A0D7',
    },
  },
  right: {
    textAlign: 'right',
    paddingRight: '16px',
  },
  paddingLeft: {
    paddingLeft: '12px',
  },
}));
